import { Controller } from '@hotwired/stimulus'
import 'bootstrap/js/src/toast'

// Connects to data-controller="toast"
export default class extends Controller {
  connect() {
    $(this.element).toast('show')

    $(this.element).on('hidden.bs.toast', () => {
      this.element.remove()
    })
  }

  disconnect() {
    $(this.element).off('hidden.bs.toast')
    $(this.element).toast('dispose')
  }

  teardown() {
    this.element.remove()
  }
}
